export default {
  CHECK_NODE: 'checkNode',
}
